<ng-container *ngFor="let slide of slideshow.slides; trackBy: utils.trackByIndex">
    <!-- template -->
    <h2 [innerHtml]="slide.title"></h2>

    <!-- image -->
    <image [slide]="slide" *ngIf="!slide.intro && slide.images.length > 0 && !slide.embedContent"></image>

    <!-- embed -->
    <embed-content *ngIf="!slide.intro && slide.embedContent" [embed]="slide.embed"></embed-content>

    <!-- summary -->
    <p *ngIf="slideshow.summary && slide.summary.length > 0">
        <span *ngFor="let p of slide.summary" [innerHtml]="p.text + '<br>'"></span>
    </p>

    <!-- content -->
    <p *ngFor="let p of slide.content" [innerHtml]="p.text"></p>
</ng-container>